
import "./Dashboard.css"; // Import your CSS file
import React, { useEffect, useState } from 'react';
import { getAllProducts } from '../apis/productApi';
const shiftData = [
  { shift: "EMS Count", lead: "EMS Occurrence", count: 30, leadCount: 50 },
  { shift: "BCS Count", lead: "BCS Occurrence", count: 20, leadCount: 60 },
  { shift: "BMS Count", lead: "BMS Occurrence", count: 40, leadCount: 70 },
  { shift: "GMS Count", lead: "GMS Occurrence", count: 60, leadCount: 20 },
  { shift: "VIS Count", lead: "VIS Occurrence", count: 10, leadCount: 24 },
  { shift: "ICL Count", lead: "ICL Occurrence", count: 30, leadCount: 21 },
];
// Array of different colors for background
// const bgColors = [
//   "#FFDDC1", 
//   "#D4E157", 
//   "#90CAF9", 
//   "#FFD54F", 
//   "#FFAB91", 
//   "#B39DDB", 
// ];
const reminders = [
  { title: "Permit Reminders", count: 1, icon: "bx bx-time", bgColor: "#E57373" },
  { title: "Insurance Reminders", count: 27, icon: "bx bx-time", bgColor: "#728E3F" },
  { title: "Quarterly Road Tax Reminders", count: 79, icon: "bx bx-time", bgColor: "#0097A7" },
  { title: "Pollution Reminders", count: 83, icon: "bx bx-time", bgColor: "#00796B" },
  { title: "Fitness Reminders", count: 13, icon: "bx bx-time", bgColor: "#C62828" },
  { title: "Lubricants Reminders", count: 0, icon: "bx bx-time", bgColor: "#E65100" },
];
// Data for brake pad wear
const brakePadData = [
  { axle: "First axle, left", percentage: 72 },
  { axle: "First axle, right", percentage: 73 },
  { axle: "Second axle, left", percentage: 99 },
  { axle: "Second axle, right", percentage: 95 },
  { axle: "Third axle, left", percentage: 45 },
  { axle: "Third axle, right", percentage: 42 },
];

// Function to determine progress bar color
const getProgressColor = (percentage) => {
  if (percentage > 75) return "bg-success"; // Green
  if (percentage > 50) return "bg-warning"; // Yellow
  return "bg-danger"; // Red
};
const faultCodes = [
  { system: "EMS", code: "S6", id: 65434, date: "16/08/2024 12:06:52", occurrences: 20 },
  { system: "BMS", code: "EBS5", id: 65515, date: "16/08/2024 12:06:59", occurrences: 29 },
  { system: "GMS", code: "OPC5", id: 50000, date: "16/08/2024 12:06:52", occurrences: 21 },
  { system: "GMS", code: "OPC5", id: 50100, date: "14/08/2024 16:51:11", occurrences: 4 },
  { system: "VIS", code: "CUV1", id: 77, date: "13/08/2024 15:39:35", occurrences: 1 },
  { system: "BCS", code: "BCS1", id: 21, date: "13/08/2024 15:43:26", occurrences: 1 },
];
const inactiveFaultCodes = [
  { system: "BMS", code: "EBS5", id: 31253, date: "16/08/2024 11:24:03", occurrences: 31 },
  { system: "BMS", code: "EBS5", id: 65511, date: "13/08/2024 17:28:44", occurrences: 1 },
  { system: "BMS", code: "EBS5", id: 2788, date: "14/08/2024 14:58:55", occurrences: 1 },
  { system: "RET", code: "RET2", id: 20041, date: "13/08/2024 17:28:44", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 770, date: "16/08/2024 09:03:00", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 771, date: "16/08/2024 09:03:07", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 773, date: "16/08/2024 09:03:03", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 774, date: "16/08/2024 09:03:05", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 775, date: "16/08/2024 09:03:05", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 776, date: "16/08/2024 09:03:02", occurrences: 1 },
  { system: "ICL", code: "ICL2", id: 785, date: "16/08/2024 09:03:06", occurrences: 1 },
  { system: "GMS", code: "OPC5", id: 50110, date: "14/08/2024 16:50:43", occurrences: 2 },
];
const fuelData = [
  { period: "23/05/2024 - 16/08/2024", per100km: 37.0, perHour: 14.8 },
  { period: "17/05/2023 - 30/05/2023", per100km: 36.1, perHour: 15.9 },
];
export default function Dashboard() {
   const [products, setProducts] = useState([]);
  
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const data = await getAllProducts();
          setProducts(data);
        } catch (error) {
          console.error('Failed to load products');
        }
      };
  
      fetchProducts();
    }, []);
  return (
    <div className="container-fluid">
      {/* start page title */}
      {/* <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Welcome !</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                <li className="breadcrumb-item active">Welcome !</li>
              </ol>
            </div>
          </div>
        </div>
      </div> */}
      {/* Page Title */}
      {/* <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">All Vehicles</h4>
          </div>
        </div>
      </div> */}

      {/* Info Card */}
      <div className="row d-flex flex-wrap align-items-center justify-content-center">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <div className="card bg-green  border-success rounded-lg p-3 shadow-sm">
            <div className="d-flex flex-wrap align-items-center justify-content-between">

              {/* Total Vehicles */}
              <div className="d-flex align-items-center gap-2">
                <i className="bx bxs-bus text-white fs-5"></i>
                <span className="fw-bold">Total :</span>
                <span className="text-blue fw-bold">{products.length}</span>
              </div>

              {/* Break Down */}
              <div className="d-flex align-items-center gap-2">
                <i className="bx bx-wrench text-white fs-5"></i>
                <span className="fw-bold">Break Down :</span>
                <span className="text-blue fw-bold">25</span>
              </div>

              {/* Idle */}
              <div className="d-flex align-items-center gap-2">
                <i className="bx bx-error-circle text-white fs-5"></i>
                <span className="fw-bold">Idle :</span>
                <span className="text-blue fw-bold">12</span>
              </div>

              {/* Working */}
              <div className="d-flex align-items-center gap-2">
                <i className="bx bx-shield text-white fs-5"></i>
                <span className="fw-bold">Working :</span>
                <span className="text-blue fw-bold">127</span>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div className="row">

        <div className="card">
          <div className="card-body">
            <h5 className=" text-center text-primary mb-3">Vehicle No. : KA01AB1234</h5>
            <div className="row">
              {/* Trips */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-trip" style={{ fontSize: '2rem', color: '#007bff' }}></i>
                    <h5 className="card-title mt-2">8</h5>
                    <p className="card-text">Trips</p>
                  </div>
                </div>
              </div>

              {/* Charge Cycles */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-battery" style={{ fontSize: '2rem', color: '#28a745' }}></i>
                    <h5 className="card-title mt-2">12</h5>
                    <p className="card-text">Charge Cycles</p>
                  </div>
                </div>
              </div>

              {/* Travelled Distance */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-map" style={{ fontSize: '2rem', color: '#dc3545' }}></i>
                    <h5 className="card-title mt-2">456</h5>
                    <p className="card-text">Travelled Distance</p>
                  </div>
                </div>
              </div>

              {/* Start ODO */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-tachometer" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
                    <h5 className="card-title mt-2">6723</h5>
                    <p className="card-text">Start ODO</p>
                  </div>
                </div>
              </div>

              {/* Vehicle Number */}
              {/* <div className="col-md-4">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-car" style={{ fontSize: '2rem', color: '#17a2b8' }}></i>
                    <h5 className="card-title mt-2">KA01AB1234</h5>
                    <p className="card-text">Vehicle Number</p>
                  </div>
                </div>
              </div> */}

              {/* End ODO */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-tachometer" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
                    <h5 className="card-title mt-2">6809</h5>
                    <p className="card-text">End ODO</p>
                  </div>
                </div>
              </div>
              {/* Km/SoC */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-line-chart" style={{ fontSize: '2rem', color: '#6610f2' }}></i>
                    <h5 className="card-title mt-2">1.72</h5>
                    <p className="card-text">Km/SoC</p>
                  </div>
                </div>
              </div>

              {/* SoC Consumed */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-battery" style={{ fontSize: '2rem', color: '#28a745' }}></i>
                    <h5 className="card-title mt-2">49</h5>
                    <p className="card-text">SoC Consumed</p>
                  </div>
                </div>
              </div>

              {/* Start SoC */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-battery" style={{ fontSize: '2rem', color: '#28a745' }}></i>
                    <h5 className="card-title mt-2">99</h5>
                    <p className="card-text">Start SoC</p>
                  </div>
                </div>
              </div>

              {/* End SoC */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-battery" style={{ fontSize: '2rem', color: '#28a745' }}></i>
                    <h5 className="card-title mt-2">49</h5>
                    <p className="card-text">End SoC</p>
                  </div>
                </div>
              </div>

              {/* SoC Accumulated */}
              <div className="col-md-2">
                <div className="card text-center mb-3 shadow">
                  <div className="card-body">
                    <i className="bx bx-plus-circle" style={{ fontSize: '2rem', color: '#17a2b8' }}></i>
                    <h5 className="card-title mt-2">3</h5>
                    <p className="card-text">SoC Accumulated</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="row">
        {shiftData.map((shift, index) => (
          <div key={index} className="col-md-2 col-sm-6 col-12 mb-0">
            <div className="card p-3 shadow border rounded">

              {/* Shift Name & Count in Same Line */}
              <div className="d-flex justify-content-between">
                <h6 className="text-muted mb-1 font-12">{shift.shift}</h6>
                <h5 className="text-success mb-1" >{shift.count}</h5>
              </div>

              {/* Lead & Lead Count in Same Line */}
              <div className="d-flex justify-content-between">
                <h6 className="text-muted mb-1">{shift.lead}</h6>
                <h5 className="text-primary mb-0">{shift.leadCount}</h5>
              </div>

            </div>
          </div>
        ))}
      </div>
      <div className="row">
        {reminders.map((reminder, index) => (
          <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
            <div
              className="d-flex justify-content-between border align-items-center p-4 rounded shadow-sm"
              style={{
                background: "#ffffff",
                borderRadius: "12px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <div>
                <h6 className="fw-bold mb-1 text-dark">{reminder.title}</h6>
                <h3 className="fw-bold text-warning">{reminder.count}</h3>
              </div>
              <div
                className="d-flex align-items-center  justify-content-center rounded-circle shadow"
                style={{
                  width: "50px",
                  height: "50px",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  color: reminder.bgColor,
                  boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)",
                }}
              >
                <i className={reminder.icon} style={{ fontSize: "22px" }}></i>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className='row'>
        {/* <div className='col-md-4 col-sm-12 col-lg-4 mb-0'></div> */}
        <div className='col-md-8 col-sm-12 col-lg-8 mb-0'>
          <div className="card shadow-lg p-4 border-0 rounded-3">
            <div className="d-flex align-items-center">
              <h5 className="fw-bold text-primary me-2">Fuel Consumption</h5>
              <i className="bx bx-link text-secondary fs-5"></i>
            </div>
            <hr />
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <tbody>
                  {fuelData.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.period}</td>
                      <td className="fw-bold text-primary">{entry.per100km} <span className="text-muted"> l/100 km</span></td>
                      <td className="fw-bold text-primary ">{entry.perHour}<span className="text-muted"> l/h</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card shadow-lg p-2 border-0 rounded-3">
            <h5 className="fw-bold text-primary">Fault Codes (16/08/2024)</h5>
            <hr />
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead className="table-secondary">
                  <tr>
                    <th>System</th>
                    <th>Code</th>
                    <th>ID</th>
                    <th>Date & Time</th>
                    <th>Occurrences</th>
                    <th>Info</th>
                  </tr>
                </thead>
                <tbody>
                  {faultCodes.map((fault, index) => (
                    <tr key={index}>
                      <td className="fw-bold">{fault.system}</td>
                      <td>{fault.code}</td>
                      <td>{fault.id}</td>
                      <td>{fault.date}</td>
                      <td>{fault.occurrences} occurrences</td>
                      <td>
                        <i className="bx bx-info-circle text-primary fs-5"></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card shadow-lg p-2 border-0 rounded-3">
            <h5 className="fw-bold text-danger">Inactive Fault Codes</h5>
            <hr />
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead className="table-secondary">
                  <tr>
                    <th>System</th>
                    <th>Code</th>
                    <th>ID</th>
                    <th>Date & Time</th>
                    <th>Occurrences</th>
                    <th>Info</th>
                  </tr>
                </thead>
                <tbody>
                  {inactiveFaultCodes.map((fault, index) => (
                    <tr key={index}>
                      <td className="fw-bold">{fault.system}</td>
                      <td>{fault.code}</td>
                      <td>{fault.id}</td>
                      <td>{fault.date}</td>
                      <td>{fault.occurrences} occurrences</td>
                      <td>
                        <i className="bx bx-info-circle text-primary fs-5"></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='col-md-4 col-sm-12 col-lg-4 mb-0'>

          <div className="card shadow-lg p-4 border-0 rounded-3" style={{ maxWidth: "500px" }}>
            <h6 className="fw-bold text-primary">K 360 IB6x2*4NB</h6>
            <hr />

            <div className="d-flex align-items-center mb-3">
              <i className="bx bx-calendar text-secondary me-2 fs-5"></i>
              <span className="fw-bold">Read-out date:</span>
              <span className="ms-auto text-dark">16/08/2024 10:25:37</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <i className="bx bx-tachometer text-secondary me-2 fs-5"></i>
              <span className="fw-bold">Odometer reading:</span>
              <span className="ms-auto text-dark fw-bold">948,457 km</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <i className="bx bx-wrench text-secondary me-2 fs-5"></i>
              <span className="fw-bold">Maintenance indicator:</span>
              <span className="ms-auto text-danger fw-bold">960,000 km</span>
            </div>

            <div className="d-flex align-items-center mb-3">
              <i className="bx bx-error text-warning me-2 fs-5"></i>
              <span className="fw-bold">Clutch disc wear:</span>
              <span className="ms-auto text-warning">⚠️</span>
            </div>

            <div className="d-flex align-items-center">
              <i className="bx bx-hash text-secondary me-2 fs-5"></i>
              <span className="fw-bold">VIN code:</span>
              <span className="ms-auto text-primary fw-bold">YS2K6X20001891212</span>
            </div>
          </div>
          <div className="card shadow-lg p-4 border-0 rounded-3" style={{ maxWidth: "500px" }}>
            <h6 className="fw-bold text-primary d-flex align-items-center">
              Remaining Allowance for Brake Pad Wear

            </h6>
            <hr />
            {brakePadData.map((item, index) => (
              <div key={index} className="mb-3">
                <span className="fw-bold">{item.axle}</span>
                <div className="progress mt-1" style={{ height: "8px" }}>
                  <div
                    className={`progress-bar ${getProgressColor(item.percentage)}`}
                    role="progressbar"
                    style={{ width: `${item.percentage}%` }}
                  ></div>
                </div>
                <span className="text-muted">{item.percentage}%</span>
              </div>
            ))}
          </div>
        </div>
        <div className='col-md-4 col-sm-12 col-lg-4 mb-0'>

        </div>
      </div>




    </div>

  )
}
